import { IPersonListState } from './states.store'
import { GetterTree } from 'vuex';

const getters: GetterTree<IPersonListState, {}> = <GetterTree<IPersonListState, {}>>{
    service: (state: IPersonListState) => state.service,
}

export default getters;